import { render } from "./VariantTable.vue?vue&type=template&id=390b576e"
import script from "./VariantTable.vue?vue&type=script&lang=js"
export * from "./VariantTable.vue?vue&type=script&lang=js"

import "./VariantTable.vue?vue&type=style&index=0&id=390b576e&lang=css"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/price-managment/VariantTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "390b576e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('390b576e', __exports__)) {
    console.log('reload')
    api.reload('390b576e', __exports__)
  }
  
  module.hot.accept("./VariantTable.vue?vue&type=template&id=390b576e", () => {
    console.log('re-render')
    api.rerender('390b576e', render)
  })

}


export default __exports__